export default __webpack_public_path__ + "static/media/practice-test-10.540c0ba3.csv";